module.exports = __webpack_public_path__ + "static/img/cover.511286a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_7/cover.jpg
// module id = hc3w
// module chunks = 0